import { GlobalMessages } from '@shared/localization/messages';

import { useUserQueryActions } from '@/api/hooks/userQueryActions';
import { useMessages } from '@/hooks/messages';

interface UserNameProps {
  userId: string | undefined;
  returnInitials?: boolean;
}

export const UserFullName: FC<UserNameProps> = ({ userId, returnInitials }) => {
  const globalMessages = useMessages(GlobalMessages);
  const { useGetUser } = useUserQueryActions();
  const { data: user } = useGetUser(userId);

  if (!user) {
    return '-';
  }

  return !returnInitials ? (
    <>
      {user.forename} {user.surname}{' '}
      {user.isActive ? null : (
        <span className='badge badge-outline-info ml-1 uppercase'>{globalMessages.inactive()}</span>
      )}
    </>
  ) : (
    `${user.forename.charAt(0)}${user.surname.charAt(0)}`
  );
};
